import { render } from "./DragIcon.vue?vue&type=template&id=30fd6d8a&scoped=true"
import script from "./DragIcon.vue?vue&type=script&lang=js"
export * from "./DragIcon.vue?vue&type=script&lang=js"

import "./DragIcon.vue?vue&type=style&index=0&id=30fd6d8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fd6d8a"]])

export default __exports__